import React, { useState } from 'react';
import SubPagesLayout from 'layouts/SubPagesLayout';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  privateBirthdayData,
  nikkahData,
  mayonData,
  walimaData,
  baraatData,
  privateCardData,
  nikkahCardData,
  walimaCardData,
  baraatCardData,
  mayonCardData,
} from 'helpers/portfolioHelper';

const PrivateEvents = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'PRIVATE EVENTS PORTFOLIO',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('Birthday');

  let [tabList] = useState([
    {
      id: 1,
      name: 'Birthday',
      active: true,
      component: (
        <TabsListing list={privateBirthdayData} cardData={privateCardData} />
      ),
    },
    {
      id: 2,
      name: 'Nikkah',
      component: <TabsListing list={nikkahData} cardData={nikkahCardData} />,
    },
    {
      id: 3,
      name: 'Mayon',
      component: <TabsListing list={mayonData} cardData={mayonCardData} />,
    },
    {
      id: 4,
      name: 'Barrat',
      component: <TabsListing list={baraatData} cardData={baraatCardData} />,
    },
    {
      id: 5,
      name: 'Walima',
      component: <TabsListing list={walimaData} cardData={walimaCardData} />,
    },
  ]);
  return (
    <section className='portfolioPage DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <CommonTab
          tabList={tabList}
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />
      </div>
    </section>
  );
};

export default SubPagesLayout({ route: 'portfolio/private events' })(
  PrivateEvents
);
